import { Link, NavLink } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { BRAND_NAME } from '../lib/brand';

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? 'nav-link active' : 'nav-link';
}

/** Wordmark with the product glyph: a miniature probability strip. */
export function Brand() {
  return (
    <Link className="brand" to="/">
      <span className="brand-mark" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className="brand-name">{BRAND_NAME}</span>
    </Link>
  );
}

/** Shared top-of-page banner: brand wordmark plus the primary navigation. */
export function SiteHeader() {
  const { session } = useAuth();

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Brand />
        <nav className="site-nav" aria-label="Primary">
          {session ? (
            <>
              <NavLink className={navClass} to="/tickers">
                Tickers
              </NavLink>
              <NavLink className={navClass} to="/watchlists">
                Watchlists
              </NavLink>
              <NavLink className={navClass} to="/account">
                Account
              </NavLink>
            </>
          ) : (
            <>
              <NavLink className={navClass} to="/signin">
                Sign in
              </NavLink>
              <NavLink className="button button-inline-nav" to="/signup">
                Create account
              </NavLink>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
